import React from 'react';
import RestShow from 'containers/rest/Show';
import RestFieldItem from 'components/RestField/RestFieldItem';

const CommentsShow = props => (
  <RestShow {...props} hasEdit resource="comments">
    <RestFieldItem source="content" header="comments.content" />
    <RestFieldItem source="createdAt" header="comments.createdAt" />
  </RestShow>
);

export default CommentsShow;
